<template>
  <div id="uploadFile">
    <van-popup
      v-model="showNav"
      closeable
      position="bottom"
      :style="{ height: '60%', width: '100%' }"
    >
      <div class="selectNav">
        <div class="select-title">选择云端文件夹</div>
        <!-- <div v-if="userId">
          <div
            class="fileList"
            :class="{ active: currentIndex === index }"
            v-for="(dir, index) in fixedDir"
            :key="dir.dir_id"
          >
            <div @click="getDirLists(dir, index)">
              <img src="../../../assets/index/wenjianjia.png" /><a>{{
                dir.dir_name
              }}</a>
            </div>
          </div>
          <div style="margin-top: 30px" @click="confirmUpload">
            <van-button type="info" style="border-radius: 30px" block
              >确定</van-button
            >
          </div>
        </div> -->
        <div v-if="userId" class="move-block">
          <div class="move-block-title">
            <van-icon name="arrow-left" color="#000" @click="returnChoose" />
            <span>上传到 {{movedName}}</span>
          </div>
          <div v-if="showMoveFlag" class="move-block-content">
            <div class="move-block-item"
            v-for="(it, i) in moveFile" :key="i"
            @click="getDirNext(it, i)">
              <img src="../../../assets/index/wenjianjia.png" />
              <span>{{it.dir_name}}</span>
            </div>
          </div>
          <div v-if="!showMoveFlag" class="move-block-item-no">暂无子文件夹</div>
          <div class="move-btn-wapper">
            <van-button class="move-btn" type="info" @click="confirmUpload">
              确定
            </van-button>
          </div>
        </div>
        <div
          style="font-size: 20px; text-align: center; margin-top: 30px"
          v-else>
          请先登录
        </div>
      </div>
    </van-popup>

    <van-overlay :show="show" @click="show = true" z-index="9999">
      <div class="wrapper">
        <van-circle
          v-model="uploadidentity"
          :rate="30"
          :speed="100"
          :text="text"
        />
      </div>
    </van-overlay>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showVanPopup: false,
      showNav: false, // 显示文件夹弹框
      smartDir: false,
      dir: {},
      currentIndex: -1,
      updateDatas: {},
      word: "",
      show: false,
      total: 0,
      updateChoose: [],
      uploadidentity: 0, // 上传进度条
      complete: 0,
      totalLast: 0,
      docFolidName: "全部文件归档",

      fixedDir: [], // 固定文件夹列表
      movedName: '', // 选择下载的文件夹名
      showMoveFlag: true, // 下载文件夹是否显示flag
      moveFile: [], // 当前文件夹
      fPath: [], // 文件夹路径
    };
  },
   props: ["uploadDocId"],
  computed: {
    userId() {
      return this.$store.state.user.userId;
    },
    changeFlag() {
      // 切换全国版 true 与地方版 false
      return this.$store.state.changeVersion.changeFlag;
    },
    // fixedDir() {
    //   return this.$store.state.fixedFolder.fixedFolderArr;
    // },
    text() {
      return this.uploadidentity.toFixed(0) + "%";
    },
  },
  created () {
    setTimeout(() => {
      this.getAllDocs()
    }, 2000);
    console.log('upload created====>')
  },
  methods: {
    // 获取所有文件夹目录
    getAllDocs () {
      this.$http.reqGetAllDocs({}).then((response) => {
        if (response.rtncode === 1) {
          if (response.rltcode === 1) {
            const data = response.data.tree
            this.fixedDir = data.children
            this.moveFile = data.children
            this.fPath.push(data)
          }
        }
      })
    },
    // 文件夹列表层级显示
    getDirNext (e, idx) {
      this.dir = e;
      this.currentIndex = idx;
      if (e.children.length >= 0) {
        this.moveFile = e.children
        this.fPath.push(e)
        this.movedName = e.dir_name
      }
      if (e.children.length == 0) {
        this.showMoveFlag = false
      }
    },

    // 返回选择的文件夹
    returnChoose () {
      this.showMoveFlag = true
      let len = this.fPath.length
      let fObj = {}
      if (len > 1) {
        this.fPath.pop()
        fObj = this.fPath[len - 2].children
        this.movedName = this.fPath[len - 2].dir_name
        this.dir = this.fPath[len - 2] //new-未
      } else {
        fObj = this.fPath[len - 1].children
        this.movedName = this.fPath[len - 1].dir_name
        this.dir = this.fPath[len - 1] //new-未
      }
      if(this.movedName == '/') {
        this.movedName = ''
        this.currentIndex = -1
      }
      this.moveFile = fObj
    },
    
    // 弹出框
    updateOrDelete(data, word) {
      if (data === undefined) {
        return this.$notify({
          color: "#fff",
          background: "#F27852",
          message: "请先搜索文件",
          duration: 3000,
        });
      }
      console.log("上传文件data===>", data);
      console.log("上传文件word===>", word);
      if (Array.isArray(data)) {
        this.updateChoose = [];
        this.updateChoose = data;
      } else {
        this.updateDatas = data;
      }
      this.word = word;
      this.showNav = true;
    },
    getDirLists(dir, index) {
      this.dir = dir;
      this.currentIndex = index;
    },
    // 上传进度条接口
    reqGetOneKey_UploadProgress(data) {
      let that = this;
      let interval = setInterval(() => {
        that.xunhuan(data);
        if (that.uploadidentity === 100) {
          clearInterval(interval);
          this.show = false;
          this.showVanPopup = false;

          this.$notify({
            color: "#fff",
            background: "#F27852",
            message: "文件上传成功",
            duration: 5000,
          });
        }
      }, 1000);
    },
    xunhuan(data) {
      this.$http
        .reqGetOneKey_UploadProgress_V2(data)
        .then((response) => {
          if (response.rtncode === 1) {
            if (response.rltcode === 1) {
              this.uploadidentity =
                ((response.item.complete / response.item.total) * 100) | 0;
              this.complete = response.item.complete;
              this.totalLast = response.item.total;
            } else {
              this.show = false;
              this.$notify({
                color: "#fff",
                background: "#F27852",
                message: response.rltdesc,
                duration: 5000,
              });
            }
          } else {
            this.show = false;
            this.$notify({
              color: "#fff",
              background: "#F27852",
              message: response.rtndesc,
              duration: 5000,
            });
          }
        })
        .catch(() => {
          this.show = false
        });
    },
    confirmUpload() {
      if (this.movedName == '') {
        this.currentIndex = -1
      }
      if (
        this.word === "最新文件" ||
        this.word === "综合检索" ||
        this.word === "进出口税收检索" ||
        this.word === "税收优惠项目" ||
        this.word === "税收优惠税种"
      ) {
        this.total = this.$parent.totalLists;
      } else if (
        this.word === "行业检索通用规定" ||
        this.word === "条约检索通用规定" ||
        this.word === "税收优惠行业通用"
      ) {
        this.total = this.$parent.commonTotal5Lists;
      } else if (
        this.word === "行业检索专属规定" ||
        this.word === "条约检索专属规定" ||
        this.word === "税收优惠行业专属"
      ) {
        this.total = this.$parent.industryTotal5lists;
      } else if (this.word === "上传城市" && !this.changeFlag) {
        this.total = this.$parent.totalLists2;
      } else if (this.word === "上传省级" && !this.changeFlag) {
        this.total = this.$parent.totalLists1;
      } else if (this.word === "上传全国" && !this.changeFlag) {
        this.total = this.$parent.totalLists;
      } else if (this.word === "选择上传") {
        this.total = this.updateChoose.length;
      } else if (this.word === "上传云端") {
        this.total = 1;
      }

      if (this.currentIndex === -1) {
        this.$notify({
          color: "#fff",
          background: "#F27852",
          message: "请先选择文件夹",
          duration: 5000,
        });
      } else if (this.currentIndex !== -1 && this.total === 0) {
        this.$notify({
          color: "#fff",
          background: "#F27852",
          message: "上传文件不能为空",
          duration: 5000,
        });
      } else {
        this.$dialog
          .confirm({
            title: "提示",
            message: `您确定上传此法规分类下的 ${this.total} 个文件到 [智慧云端] 吗 ?`,
          })
          .then(() => {
            if (this.word !== "上传云端") {
              this.show = true;
              this.showVanPopup = true;
              this.showNav = false;
              this.uploadidentity = 0;
            }
            if (this.word === "最新文件") {
              this.updateDatas.frist.dirid = this.dir.dir_id;
              this.updateDatas.fliter.isfilter = true;
              let args = this.updateDatas;

              this.$http
                .reqOneKeyLastFiles(args)
                .then((response) => {
                  if (response.rtncode === 1) {
                    if (response.rltcode === 1) {
                      this.$parent.backStatus();
                      this.$parent.clearResult();
                      this.reqGetOneKey_UploadProgress(response.uploadidentity);
                    } else {
                      this.show = false;
                      this.$notify({
                        color: "#fff",
                        background: "#F27852",
                        message: response.rltdesc,
                        duration: 5000,
                      });
                    }
                  } else {
                    this.show = false;
                    this.$notify({
                      color: "#fff",
                      background: "#F27852",
                      message: response.rtndesc,
                      duration: 5000,
                    });
                  }
                })
                .catch(() => {
                  this.show = false
                });
            } else if (this.word === "综合检索") {
              console.log("综合检索this.updateDatas", this.updateDatas);
              this.updateDatas.frist.dirid = this.dir.dir_id;
              // if (this.updateDatas.fliter.tagpc.length !== 0) {
              //   this.updateDatas.fliter.isfilter = true;
              // } else {
              //   this.updateDatas.fliter.isfilter = false;
              // }
              let args = this.updateDatas;
              this.$http
                .reqOneKeyGeneralFiles_V2(args)
                .then((response) => {
                  if (response.rtncode === 1) {
                    if (response.rltcode === 1) {
                      //     this.show = false
                      //     this.$notify({ color: '#fff',
                      // background: '#b99573', message: '文件上传成功' })
                      this.$parent.backStatus();
                      this.$parent.clearResult();
                      this.reqGetOneKey_UploadProgress(response.uploadidentity);
                      
                    } else {
                      this.show = false;
                      this.$notify({
                        color: "#fff",
                        background: "#F27852",
                        message: response.rltdesc,
                        duration: 5000,
                      });
                    }
                  } else {
                    this.show = false;
                    this.$notify({
                      color: "#fff",
                      background: "#F27852",
                      message: response.rtndesc,
                      duration: 5000,
                    });
                  }
                })
                .catch(() => {
                  this.show = false;
                });
            } else if (this.word === "行业检索通用规定") {
              console.log("行业检索通用规定69", this.updateDatas);
              this.updateDatas.frist.dirid = this.dir.dir_id;
              this.updateDatas.fliter.isfilter = true;
              let args = this.updateDatas;
              this.$http
                .reqOneKeyIndustryCommonFiles_V2(args)
                .then((response) => {
                  if (response.rtncode === 1) {
                    if (response.rltcode === 1) {
                      //     this.show = false
                      //     this.$notify({ color: '#fff',
                      // background: '#b99573', message: '文件上传成功' })
                      this.$parent.backStatus();
                      this.$parent.clearResult();
                      this.reqGetOneKey_UploadProgress(response.uploadidentity);
                    } else {
                      this.show = false;
                      this.$notify({
                        color: "#fff",
                        background: "#F27852",
                        message: response.rltdesc,
                        duration: 5000,
                      });
                    }
                  } else {
                    this.show = false;
                    this.$notify({
                      color: "#fff",
                      background: "#F27852",
                      message: response.rtndesc,
                      duration: 5000,
                    });
                  }
                })
                .catch(() => {
                  this.show = false
                });
            } else if (this.word === "行业检索专属规定") {
              this.updateDatas.frist.dirid = this.dir.dir_id;
              this.updateDatas.fliter.isfilter = true;
              let args = this.updateDatas;
              this.$http
                .reqOneKeyIndustrySpecialFiles_V2(args)
                .then((response) => {
                  if (response.rtncode === 1) {
                    if (response.rltcode === 1) {
                      // this.show = false
                      // this.$notify({ type: 'success', message: '文件上传成功' })
                      this.$parent.backStatus();
                      this.$parent.clearResult();
                      this.reqGetOneKey_UploadProgress(response.uploadidentity);
                    } else {
                      this.show = false;
                      this.$notify({
                        color: "#fff",
                        background: "#F27852",
                        message: response.rltdesc,
                        duration: 5000,
                      });
                    }
                  } else {
                    this.show = false;
                    this.$notify({
                      color: "#fff",
                      background: "#F27852",
                      message: response.rtndesc,
                    });
                  }
                })
                .catch(() => {
                  this.show = false;
                });
            } else if (this.word === "税收优惠项目") {
              this.updateDatas.frist.dirid = this.dir.dir_id;
              this.updateDatas.fliter.isfilter = true;
              let args = this.updateDatas;
              this.$http
                .reqOneKeyTaxBreakFiles_item_V2(args)
                .then((response) => {
                  if (response.rtncode === 1) {
                    if (response.rltcode === 1) {
                      // this.show = false
                      // this.$notify({ type: 'success', message: '文件上传成功' })
                      this.$parent.backStatus();
                      this.$parent.clearResult();
                      this.reqGetOneKey_UploadProgress(response.uploadidentity);
                    } else {
                      this.show = false;
                      this.$notify({
                        color: "#fff",
                        background: "#F27852",
                        message: response.rltdesc,
                        duration: 5000,
                      });
                    }
                  } else {
                    this.show = false;
                    this.$notify({
                      color: "#fff",
                      background: "#F27852",
                      message: response.rtndesc,
                      duration: 5000,
                    });
                  }
                })
                .catch(() => {
                  this.show = false
                });
            } else if (this.word === "税收优惠税种") {
              this.updateDatas.frist.dirid = this.dir.dir_id;
              this.updateDatas.fliter.isfilter = true;
              let args = this.updateDatas
              this.$http
                .reqOneKeyTaxBreakFiles_taxes_V2(args)
                .then((response) => {
                  if (response.rtncode === 1) {
                    if (response.rltcode === 1) {
                      //     this.show = false
                      //     this.$notify({ color: '#fff',
                      // background: '#b99573', message: '文件上传成功' })
                      this.$parent.backStatus();
                      this.$parent.clearResult();
                      this.reqGetOneKey_UploadProgress(response.uploadidentity);
                    } else {
                      this.show = false;
                      this.$notify({
                        color: "#fff",
                        background: "#F27852",
                        message: response.rltdesc,
                        duration: 5000,
                      });
                    }
                  } else {
                    this.show = false;
                    this.$notify({
                      color: "#fff",
                      background: "#F27852",
                      message: response.rtndesc,
                      duration: 5000,
                    });
                  }
                })
                .catch(() => {
                  this.show = false
                });
            } else if (this.word === "税收优惠行业通用") {
              console.log("税收优惠行业通用", this.updateDatas);
              this.updateDatas.frist.dirid = this.dir.dir_id;
              this.updateDatas.fliter.isfilter = true;
              let args = this.updateDatas;
              this.$http
                .reqOneKeyTaxBreakFiles_common_V2(args)
                .then((response) => {
                  if (response.rtncode === 1) {
                    if (response.rltcode === 1) {
                      //     this.show = false
                      //     this.$notify({ color: '#fff',
                      // background: '#b99573', message: '文件上传成功' })
                      this.$parent.backStatus();
                      this.$parent.clearResult();
                      this.reqGetOneKey_UploadProgress(response.uploadidentity);
                    } else {
                      this.show = false;
                      this.$notify({
                        color: "#fff",
                        background: "#F27852",
                        message: response.rltdesc,
                        duration: 5000,
                      });
                    }
                  } else {
                    this.show = false;
                    this.$notify({
                      color: "#fff",
                      background: "#F27852",
                      message: response.rtndesc,
                      duration: 5000,
                    });
                  }
                })
                .catch(() => {
                  this.show = false;
                });
            } else if (this.word === "税收优惠行业专属") {
              this.updateDatas.frist.dirid = this.dir.dir_id;
              this.updateDatas.fliter.isfilter = true;
              let args = this.updateDatas
              this.$http
                .reqOneKeyTaxBreakFiles_special_V2(args)
                .then((response) => {
                  if (response.rtncode === 1) {
                    if (response.rltcode === 1) {
                      //     this.show = false
                      //     this.$notify({ color: '#fff',
                      // background: '#b99573', message: '文件上传成功' })
                      this.$parent.backStatus();
                      this.$parent.clearResult();
                      this.reqGetOneKey_UploadProgress(response.uploadidentity);
                    } else {
                      this.show = false;
                      this.$notify({
                        color: "#fff",
                        background: "#F27852",
                        message: response.rltdesc,
                        duration: 5000,
                      });
                    }
                  } else {
                    this.show = false;
                    this.$notify({
                      color: "#fff",
                      background: "#F27852",
                      message: response.rtndesc,
                      duration: 5000,
                    });
                  }
                })
                .catch(() => {
                  this.show = false;
                });
            } else if (this.word === "条约检索通用规定") {
              this.updateDatas.frist.dirid = this.dir.dir_id;
              this.updateDatas.fliter.isfilter = true;
              let args = this.updateDatas;
              this.$http
                .reqOneKeyTreatyCommonFiles_V2(args)
                .then((response) => {
                  if (response.rtncode === 1) {
                    if (response.rltcode === 1) {
                      // this.show = false
                      // this.$notify({ type: 'success', message: '文件上传成功' })
                      this.$parent.backStatus();
                      this.$parent.clearResult();
                      this.reqGetOneKey_UploadProgress(response.uploadidentity);
                    } else {
                      this.show = false;
                      this.$notify({
                        color: "#fff",
                        background: "#F27852",
                        message: response.rltdesc,
                        duration: 5000,
                      });
                    }
                  } else {
                    this.show = false;
                    this.$notify({
                      color: "#fff",
                      background: "#F27852",
                      message: response.rtndesc,
                      duration: 5000,
                    });
                  }
                })
                .catch(() => {
                  this.show = false;
                });
            } else if (this.word === "条约检索专属规定") {
              this.updateDatas.frist.dirid = this.dir.dir_id;
              this.updateDatas.fliter.isfilter = true;
              let args = this.updateDatas;
              this.$http
                .reqOneKeyTreatySpecialFiles_V2(args)
                .then((response) => {
                  if (response.rtncode === 1) {
                    if (response.rltcode === 1) {
                      //     this.show = false
                      //     this.$notify({ color: '#fff',
                      // background: '#b99573', message: '文件上传成功' })
                      this.$parent.backStatus();
                      this.$parent.clearResult();
                      this.reqGetOneKey_UploadProgress(response.uploadidentity);
                    } else {
                      this.show = false;
                      this.$notify({
                        color: "#fff",
                        background: "#F27852",
                        message: response.rltdesc,
                        duration: 5000,
                      });
                    }
                  } else {
                    this.show = false;
                    this.$notify({
                      color: "#fff",
                      background: "#F27852",
                      message: response.rtndesc,
                      duration: 5000,
                    });
                  }
                })
                .catch(() => {
                  this.show = false;
                });
            } else if (this.word === "进出口税收检索") {
              this.updateDatas.frist.dirid = this.dir.dir_id;
              this.updateDatas.fliter.isfilter = true;
              let args = this.updateDatas;
              this.$http
                .reqOneKeyInoutFiles_V2(args)
                .then((response) => {
                  if (response.rtncode === 1) {
                    if (response.rltcode === 1) {
                      //     this.show = false
                      //     this.$notify({ color: '#fff',
                      // background: '#b99573', message: '文件上传成功' })
                      this.$parent.backStatus();
                      this.$parent.clearResult();
                      this.reqGetOneKey_UploadProgress(response.uploadidentity);
                    } else {
                      this.show = false;
                      this.$notify({
                        color: "#fff",
                        background: "#F27852",
                        message: response.rltdesc,
                        duration: 5000,
                      });
                    }
                  } else {
                    this.show = false;
                    this.$notify({
                      color: "#fff",
                      background: "#F27852",
                      message: response.rtndesc,
                      duration: 5000,
                    });
                  }
                })
                .catch(() => {
                  this.show = false;
                });
            } else if (this.word === "选择上传") {
              console.log(
                "选择888",
                this.updateChoose
              );
              this.$http
                .upLoadFileToCloud(this.updateChoose, this.dir.dir_id)
                .then((response) => {
                  if (response.rtncode === 1) {
                    if (response.rltcode === 1) {
                      this.show = false;
                      this.$notify({
                        color: "#fff",
                        background: "#F27852",
                        message: "文件上传成功",
                        duration: 5000,
                      });
                      this.$store.commit("choose/setChooseUp2", "选择上传");
                      // 恢复按钮的状态
                      this.$parent.backStatus();
                      this.$parent.clearResult();
                    } else {
                      this.show = false;
                      this.$notify({
                        color: "#fff",
                        background: "#F27852",
                        message: response.rltdesc,
                        duration: 5000,
                      });
                    }
                  } else {
                    this.show = false;
                    this.$notify({
                      color: "#fff",
                      background: "#F27852",
                      message: response.rtndesc,
                      duration: 5000,
                    });
                  }
                })
                .catch(() => {
                  this.show = false;
                });
            } else if (
              this.word === "上传城市" ||
              this.word === "上传省级" ||
              this.word === "上传全国"
            ) {
              this.updateDatas.frist.dirid = this.dir.dir_id;
              this.updateDatas.fliter.isfilter = true;
              if (this.word === "上传城市") {
                this.updateDatas.fliter.tagpc = [
                  {
                    p: this.updateDatas.frist.ps.p,
                    c: this.updateDatas.frist.ps.c,
                    t: "",
                  },
                ];
              } else if (this.word === "上传省级") {
                this.updateDatas.fliter.tagpc = [
                  {
                    p: this.updateDatas.frist.ps.p,
                    c: "000000",
                    t: "",
                  },
                ];
              } else if (this.word === "上传全国") {
                this.updateDatas.fliter.tagpc = [
                  {
                    p: "000000",
                    c: "000000",
                    t: "",
                  },
                ];
              }
              let args = this.updateDatas;
              
              this.$http
                .reqOneKeyLocalUpload_V2(args)
                .then((response) => {
                  if (response.rtncode === 1) {
                    if (response.rltcode === 1) {
                      //     this.show = false
                      //     this.$notify({ color: '#fff',
                      // background: '#b99573', message: '文件上传成功' })
                      this.$parent.backStatus();
                      this.$parent.clearResult();
                      this.reqGetOneKey_UploadProgress(response.uploadidentity);
                    } else {
                      this.show = false;
                      this.$notify({
                        color: "#fff",
                        background: "#F27852",
                        message: response.rltdesc,
                        duration: 5000,
                      });
                    }
                  } else {
                    this.show = false;
                    this.$notify({
                      color: "#fff",
                      background: "#F27852",
                      message: response.rtndesc,
                      duration: 5000,
                    });
                  }
                })
                .catch(() => {
                  this.show = false;
                });
            } else if (this.word === '上传云端') {
              this.$http.upLoadFileToCloud(this.uploadDocId, this.dir.dir_id)
              .then((response) => {
                if (response.rtncode === 1) {
                  if (response.rltcode === 1) {
                    this.$notify({
                      color: "#fff",
                      background: "#F27852",
                      message: `文件已成功上传至智慧云端-上传文件库-${this.dir.dir_name}`
                    })
                    this.showNav = false;
                  } else {
                    this.$notify({
                      color: "#fff",
                      background: "#F27852",
                      message: response.rltdesc,
                      duration: 5000
                    })
                  }
                } else {
                  this.$notify({
                    color: "#fff",
                    background: "#F27852",
                    message: response.rtndesc,
                    duration: 5000
                  })
                }
              })
            }
          })
          .catch(() => {
            // on cancel
          });
      }
    },
  },
};
</script>

<style lang="less" scoped>
#uploadFile {
  /deep/.van-popup {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  /deep/.van-icon {
    color: #000;
  }
  .move-block {
    display: flex;
    flex-direction: column;
    overflow-y: scroll;
    padding: 20px 20px 0 20px;
    .move-block-title {
      color: #000000;
      display: flex;
      align-items: center;
      margin-bottom: 10px;
    }
    .move-block-content {
      height: calc(100vh - 300px);
      overflow-y: auto;
    }
    .move-block-item {
      margin: 10px 0 10px 0;
      position: relative;
      border-bottom: 1px solid #f3f1f1;
      padding-bottom: 13px;
    }
    .move-block-item-no {
      margin: 30px 0 0 30px;
      position: relative;
    }
    img {
      width: 20px;
      height: 20px;
      margin: 0 10px;
    }
    .move-btn-wapper {
      position: absolute;
      bottom: 20px;
      left: 0;
      right: 0;
      text-align: center;
      padding: 0 30px;
      .move-btn {
        margin: 30px 10px 0 0;
        border-radius: 30px;
        width: 90%;
      }
    }
  }
  .fileList {
    font-size: 14px;
    padding: 12px 20px;
    border-bottom: 1px solid #f3f3f3;
    img {
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }
    a {
      position: relative;
      top: -5px;
      color: #333;
    }
  }
  .active {
    background: #ecf9ff;
  }
  .selectNav {
    .select-title {
      color: #000000;
      font-size: 16px;
      text-align: center;
      font-weight: bold;
    }
  }
}
</style>
<style>
.van-circle__text {
  color: #fff;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
